import React, { PropTypes } from 'react'
import {Card, CardHeader, CardText} from 'material-ui/Card'
import { blue500, red500 } from 'material-ui/styles/colors'

import Warning from 'material-ui/svg-icons/alert/warning'
import Power from 'material-ui/svg-icons/notification/power'

const FREQUENCY_INVERTER_ERROR_ROLE = 38
const PHASE_VALIDATION_ROLE = 10

const styles = {
  icon: {
    height: 'inherit',
    width: '80%',
    marginLeft: '10%'
  }
}

const EnergyIcon = (props) => {
  const {isProblemDetected, ...rest} = props
  if (isProblemDetected) {
    return <Warning {...rest} color={red500} />
  }
  return <Power {...rest} color={blue500} />
}

const Energy = ({style, informations}) => {
  let frequencyInverterError = null
  let phaseValidation = null

  informations.forEach(information => {
    if (information.role === FREQUENCY_INVERTER_ERROR_ROLE) {
      frequencyInverterError = information
    }
    if (information.role === PHASE_VALIDATION_ROLE) {
      phaseValidation = information
    }
  })

  let isProblemDetected = false

  if (frequencyInverterError) {
    isProblemDetected = frequencyInverterError.updates.length > 0 && frequencyInverterError.updates[0].data === 1
  }

  if (phaseValidation) {
    isProblemDetected = phaseValidation.updates.length > 0 && phaseValidation.updates[0].data === 0
  }

  return (
    <Card style={style}>
      <CardHeader
        title="Alimentação Elétrica"
        subtitle={isProblemDetected ? 'Desligado (Entre em contato com a COSERN)' : 'Ligado'}
        textStyle={{padding: 0}}
        style={{paddingBottom: 0}} />
      <CardText>
        <EnergyIcon
          isProblemDetected={isProblemDetected}
          style={styles.icon} />
      </CardText>
    </Card>
  )
}

Energy.propTypes = {
  informations: PropTypes.array.isRequired
}

export default Energy



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/Energy.js
 **/